{
  "name": "bueno-frontend",
  "version": "2.0.6",
  "buildTimestamp": "2026-07-29T12:09:15.068Z",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "npm run generate:version && ng build",
    "build:production": "npm run generate:version && ng build --configuration production",
    "build:sandbox": "npm run generate:version && ng build --configuration sandbox",
    "build:chat-webcomponent": "ng build --configuration chat-webcomponent",
    "lint": "ng lint",
    "lint-fix": "ng lint --fix",
    "e2e": "ng e2e",
    "watch": "npm run generate:version && ng build --watch --configuration development",
    "test": "ng test",
    "build-bulma": "sass --load-path=node_modules src/styles/bulma/custom-bulma-styles.scss src/bulma/custom-bulma-styles.css",
    "format": "prettier --write \"src/**/*.{ts,html,css,scss}\"",
    "format:check": "prettier --check \"src/**/*.{ts,html,css,scss}\"",
    "generate:version": "node tools/write-app-version.mjs",
    "serve:ssl": "ng serve --ssl --ssl-cert ./.cert/localhost.pem --ssl-key ./.cert/localhost-key.pem --host localhost --port 4200",
    "start:ssl": "node tools/start-ssl.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular-magic/ngx-gp-autocomplete": "^2.0.2",
    "@angular/animations": "^20.3.6",
    "@angular/cdk": "^20.2.9",
    "@angular/common": "^20.3.6",
    "@angular/compiler": "^20.3.6",
    "@angular/core": "^20.3.6",
    "@angular/elements": "^20.3.3",
    "@angular/forms": "^20.3.6",
    "@angular/google-maps": "^20.2.9",
    "@angular/material": "^20.2.9",
    "@angular/platform-browser": "^20.3.6",
    "@angular/platform-browser-dynamic": "^20.3.6",
    "@angular/router": "^20.3.6",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@fortawesome/pro-duotone-svg-icons": "^7.1.0",
    "@fortawesome/pro-light-svg-icons": "^7.1.0",
    "@fortawesome/pro-regular-svg-icons": "^7.1.0",
    "@fortawesome/pro-solid-svg-icons": "^7.1.0",
    "@fortawesome/pro-thin-svg-icons": "^7.1.0",
    "@fortawesome/sharp-solid-svg-icons": "^7.1.0",
    "@googlemaps/js-api-loader": "^2.0.1",
    "@maskito/angular": "^4.0.0",
    "@maskito/core": "^4.0.0",
    "@maskito/kit": "^4.0.0",
    "@microsoft/signalr": "^9.0.6",
    "@ng-icons/core": "^32.2.0",
    "@ng-icons/heroicons": "^32.2.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular-ivy": "^7.120.4",
    "@types/google.maps": "3.65.2",
    "angular-code-input": "^2.0.0",
    "angular-iban": "^20.0.0",
    "angular-oauth2-oidc": "^20.0.2",
    "angular-oauth2-oidc-jwks": "^20.0.0",
    "bootstrap": "^5.3.8",
    "bulma": "^1.0.4",
    "bulma-block-list": "^1.1.0",
    "bulma-floating-button": "^1.0.3",
    "bulma-list": "^3.0.0",
    "bulma-o-steps": "^1.1.0",
    "firebase": "^12.8.0",
    "html2canvas": "^1.4.1",
    "iban": "^0.0.14",
    "libphonenumber-js": "^1.12.24",
    "lottie-web": "^5.13.0",
    "luxon": "^3.7.2",
    "ng-recaptcha-2": "^16.0.1",
    "ngx-cookie-service": "^20.1.0",
    "ngx-device-detector": "^10.1.0",
    "ngx-extended-pdf-viewer": "^25.5.1",
    "ngx-infinite-scroll": "^20.0.0",
    "ngx-lottie": "^20.0.0",
    "ngx-mask": "^20.0.3",
    "ngx-masonry": "^14.0.1",
    "postcode-validator": "^3.10.5",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.2",
    "sass": "^1.93.2",
    "svg-country-flags": "^1.2.10",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "optionalDependencies": {
    "@esbuild/linux-x64": "0.25.11"
  },
  "devDependencies": {
    "@angular-eslint/builder": "20.4.0",
    "@angular-eslint/eslint-plugin": "20.4.0",
    "@angular-eslint/eslint-plugin-template": "20.4.0",
    "@angular-eslint/schematics": "20.4.0",
    "@angular-eslint/template-parser": "20.4.0",
    "@angular/build": "^20.3.6",
    "@angular/cli": "~20.3.6",
    "@angular/compiler-cli": "^20.3.6",
    "@angular/localize": "^20.3.6",
    "@types/iban": "^0.0.35",
    "@types/jasmine": "~5.1.12",
    "@types/luxon": "^3.7.1",
    "@types/qrcode": "^1.5.6",
    "@typescript-eslint/eslint-plugin": "8.46.2",
    "@typescript-eslint/parser": "8.46.2",
    "baseline-browser-mapping": "^2.9.14",
    "eslint": "^9.38.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "jasmine-core": "~5.12.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.6.2",
    "prettier-plugin-organize-imports": "^4.3.0",
    "typescript": "~5.9.3"
  }
}
